export default __webpack_public_path__ + "static/media/Talent_Unstable.921bf394.png";